import React, { useEffect, useState } from 'react'
import './Tabs.sass'
import PropTypes from 'prop-types'

const Tabs = ({ titles, children, id, onClick }) => {
  const [active, updateActive] = useState(0)

  useEffect(() => {
    if (id) {
      const setter = {}
      setter[id] = (active) => updateActive(active)
      window.updateTab = window.updateTab
        ? { ...window.updateTab, ...setter }
        : setter
    }
  }, [id])

  const tabID = new Date().getTime().toString()

  return (
    <div className='defaultTabs'>
      <div className='titles'>
        {titles.map((title, i) => (
          <div
            className={'title' + (i === active ? ' active' : '')}
            key={'tabTitle' + tabID + i}
            onClick={() => {
              updateActive(i)
              onClick(i)
            }}
          >
            <p>{title}</p>
          </div>
        ))}
      </div>
      <div className='content'>{children(active, updateActive)}</div>
    </div>
  )
}

Tabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.func.isRequired,
  onClick: PropTypes.func,
}

Tabs.defaultProps = {
  onClick: () => {},
}

export default Tabs
